import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcAnamnesis = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={52}
    height={52}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52 52"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <rect fill="#EEF4FF" width={52} height={52} rx={4} />
      <path
        d="M31.3 42.996c1.704 0 3.093-.922 3.12-2.626v-1.34a.67.67 0 0 1 .65-.64h3.5a1 1 0 0 0 1-1s0 2.3-2.67 4.31c-1.601 1.165-3.53 1.351-5.51 1.356l-.09-.06Z"
        fill="#5590FF"
        fillRule="nonzero"
        opacity={0.6}
      />
      <path
        d="M13.58 9a1.08 1.08 0 0 0-1.09 1.08v31.835a1.08 1.08 0 0 0 1.09 1.08H31.3a3.12 3.12 0 0 0 3.12-3.07v-1.33a.65.65 0 0 1 .65-.64h3.5a1 1 0 0 0 1-1V10.08A1.08 1.08 0 0 0 38.48 9h-24.9Z"
        stroke="#5590FF"
        fill="#D4E4FF"
        fillRule="nonzero"
        strokeLinejoin="round"
      />
      <path
        d="M16.42 14h6-6ZM39.57 37.037s.05 2.625-2.62 4.708c-1.601 1.207-3.55 1.246-5.53 1.25M16.42 20h19.075H16.42ZM16.42 24h19.075H16.42ZM16.42 28h9-9Z"
        stroke="#5590FF"
        strokeLinecap="round"
      />
      <path d="M16.42 38h9-9ZM16.42 40h5-5Z" stroke="#5590FF" />
    </g>
  </svg>
);
export default SvgIcAnamnesis;
